export const LoginRoutesConst = {
  LoginLayout: "LoginLayout",
  Dashboard: "Dashboard",
  UseForme: "UseForme",
  AddFirstKid: "AddFirstKid",
  AddAdditionalKid: "AddAdditionalKid",
  MyKid: "MyKid",
  MyKidReport: "MyKidReport",
  MyPage: "MyPage",
  AccountManagement: "AccountManagement",
  DeleteKid: "DeleteKid",
  MyKidContent: "MyKidContent",
  PatchKid: "PatchKid",
  ExtensionCode: "ExtensionCode",
  MyKidSurvey: "MyKidSurvey",
  ShowHowToUse: "ShowHowToUse",
  MyKidPromise: "MyKidPromise",
  MyKidState: "MyKidState",
} as const;

export const LogoutRoutesConst = {
  LogoutLayout: "LogoutLayout",
  SignIn: "SignIn",
} as const;

export const CommonRoutesConst = {
  Policy: "Policy",
  Exit: "Exit",
} as const;

export const StepParamConst = {
  kidInfo: "kidInfo",
  license: "license",
  qrcode: "qrcode",
} as const;

export type BeforeStartType = "Dashboard" | "UseForme" | "MyKid";

export type SurveyQuestionType = {
  index: number;
  category: string;
  question: string;
};

export type BeforeEvaluationType = "behaviorEvaluation" | "mindState";

export type SelectWeekParentType =
  | "UseForme"
  | "MyKidReportSurvey"
  | "MyKidReportState"
  | "CNT"

export type KidReportCategoryType =
  | "selfControl"
  | "mood"
  | "metaCognitive"
  | "mindState";

export type SelfControlFeatureType =
  | "Achievement"
  | "Responsibility"
  | "Attention";

export type MoodFeatureType = "Sadness" | "Anger" | "Resilience";

export type MetaCognitiveFeatureType = "Mindful" | "Monitoring" | "Neat";

export type MindStateFeatureType = "anxiety" | "gloom" | "stress";
export type MyKidReportFeatureDetailType = {
  key: string;
  title: string;
  content: string;
  avg?: number;
};

export type MyKidReportContentType =
  | Record<SelfControlFeatureType, MyKidReportFeatureDetailType>
  | Record<MoodFeatureType, MyKidReportFeatureDetailType>
  | Record<MetaCognitiveFeatureType, MyKidReportFeatureDetailType>
  | Record<MindStateFeatureType, MyKidReportFeatureDetailType>;
